var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantomePinceDoigt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 963.98 872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#ffd93b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fantome 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1437.45,1377H520.25c-17.52,0-28.53-19.42-19.88-35.08l455.09-824a22.56,22.56,0,0,1,39.69-.14l462.1,824C1466,1357.45,1455,1377,1437.45,1377Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1346.57,1316.5H603.13c-14.2,0-23.13-15.74-16.12-28.43L955.89,620.14a18.29,18.29,0,0,1,32.17-.11L1362.63,1288C1369.74,1300.65,1360.83,1316.5,1346.57,1316.5Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178,1212c-15,22-46,34-46,34H917c-14,0-15-27,0-27h104v-6H885c-15,0-16-33,0-33h135v-6H866c-20,0-20-32,0-32h154v-7H885c-18,0-18-31,0-31l136-1v-7H979c-21,0-23-24-23-24h172c40,0,48,32,48,32h42v109Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.64,
    y: 573,
    width: 192,
    height: 18
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.14 513.5 388.14 513.5 353.14 558.5 311.14 513.5 334.14 513.5 334.14 431.5 368.14 431.5 368.14 513.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.14,
    y: 751.5,
    width: 193,
    height: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantomePinceDoigt);
export default __webpack_public_path__ + "static/media/fantome_pince_doigt.66a2f7d7e23cab425305b47bdf2529c9.svg";
export { ForwardRef as ReactComponent };